import { Record } from 'immutable';

const CoreAndCatchUpRecord = Record({
  unitNo: undefined,
  lessonCategory: undefined,
  lessonNo: undefined,
  studentActivities: undefined,
});

class CoreAndCatchUp extends CoreAndCatchUpRecord {}

export default CoreAndCatchUp;



// WEBPACK FOOTER //
// ./data/WritingAssignment/CoreAndCatchUp/model.js